import { useContext } from 'react';
import CurrentCompanyContext from '../contexts/CurrentCompanyContext';

const useCurrentCompany = () => (
  useContext(CurrentCompanyContext)
);

export default useCurrentCompany;
